<template>
<el-container>
 <el-main style="width:100%;height:100%;background-color:#061B30;">
  <el-form :inline="true" :model="selectForm" ref="selectForm" class="demo-ruleForm">
     <el-form-item :label="$t('roomList.apartment')">
        <el-select style="width:180px" v-model="selectForm.apartmentId" filterable @change="apartmentSelectChange" :placeholder="$t('roomList.choose')">
          <el-option
           v-for="item in apartmentOptions"
           :key="item.apartmentId"
           :label="item.apartmentName"
           :value="item.apartmentId">
          </el-option>
        </el-select>
      </el-form-item>
     
      <el-form-item :label="$t('roomList.buildingName')">
        <el-select style="width:180px" v-model="selectForm.buildingId" @change="buildingSelectChange" :placeholder="$t('roomList.choose')">
          <el-option
           v-for="item in buildingOptions"
           :key="item.buildingId"
           :label="item.buildingName"
           :value="item.buildingId">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('roomList.floorName')">
        <el-select style="width:180px" clearable v-model="selectForm.floorId" @change="floorSelectChange" :placeholder="$t('roomList.choose')">
          <el-option
           v-for="item in floorOptions"
           :key="item.floorId"
           :label="item.floorName"
           :value="item.floorId">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('apartmentRoomDetail.roomName')">
          <el-select style="width:180px" v-model="selectForm.roomId" filterable :placeholder="$t('deviceList.chooseRoom')">
         <el-option
          v-for="item in roomOptions"
          :key="item.roomId"
          :label="item.roomName"
          :value="item.roomId">
         </el-option>
        </el-select>
      </el-form-item>

      <el-form-item  :label="$t('commom.yearMonth')">
        <el-date-picker
          style="width:170px"
          v-model="selectForm.yearMonth"
          type="month"
          placeholder=""
          value-format="yyyy-MM"
        >
        </el-date-picker>
      </el-form-item> 

       <el-form-item>
        <el-button type="primary"  icon="el-icon-search" @click="onSelect">{{$t('roomList.search')}}</el-button>
      </el-form-item>

  </el-form>  
   <div id="main" style="width:100%;height:380px;background-color:#062443;float:left"></div>
  </el-main>
</el-container>  
</template>

<script>
export default {
 name: "Container",
  data() {
     return {
       selectForm:{
         buildingId:"",
         floorId:"",
         roomId:"",
         roomName:"",
         yearMonth:''
       },
       apartmentOptions:[],
       buildingOptions:[],
       floorOptions:[],
       roomOptions:[]
     }
  },
  components: {
     
  }, 
  mounted: function() {
      this.echartsInit(null,null,null);
      this.getApartmentList();
  },
  methods: {
    //查询按钮
    onSelect(){
       if(this.selectForm.roomId==""||this.selectForm.roomId==null){
          this.$message({
            message:this.$t("commom.qxzycxdfj"),
            type: "warning"
          });
          return false;
       }
       this.getUnlockStatistics();
    },
    //公寓改变值事件
    apartmentSelectChange(){
         this.getBuildingList();
         this.floorOptions=[];
    },

    //楼栋下拉选择值改变事件
    buildingSelectChange(){
      if(this.selectForm.buildingId==""||this.selectForm.buildingId==null){
         this.floorOptions=[];
         this.selectForm.floorId="";
      }else{
        this.getFloorList();
      }
      
    },
    
    floorSelectChange(){
      if(this.selectForm.floorId==""||this.selectForm.floorId==null){
         this.roomOptions=[];
         this.selectForm.roomId="";
      }else{
        this.getRoomList();
      }
    },

    getRoomList(){
      var formData = new FormData();
      formData.append("apartmentId",this.selectForm.apartmentId);
      formData.append("buildingId",this.selectForm.buildingId);
      formData.append("floorId",this.selectForm.floorId);
      this.$server.exam("/customer/apartment/listBaseRoom", formData).then(data => {
        if (data.code == 200) {
          this.roomOptions = data.data;
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },

    getFloorList(){
      var formData = new FormData();
      formData.append("apartmentId",this.selectForm.apartmentId);
      formData.append("buildingId",this.selectForm.buildingId);
      this.$server
      .exam("/customer/apartment/listBaseFloor", formData)
      .then(data => {
        if (data.code == 200) {
          this.floorOptions=data.data;    
          this.addFloorOptions=data.data;      
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
    },

    getBuildingList(){
      var formData = new FormData();
      if(this.selectForm.apartmentId!=""&&this.selectForm.apartmentId!=null){
        formData.append("apartmentId", this.selectForm.apartmentId);
      }
      this.$server
      .exam("/customer/apartment/listBaseBuilding", formData)
      .then(data => {
        if (data.code == 200) {
          this.buildingOptions=data.data;
          this.addBuildingOptions=data.data;          
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
    },

    getApartmentList(){
      var formData = new FormData();
      this.$server
      .exam("/customer/apartment/listOwnerApartment", formData)
      .then(data => {
        if (data.code == 200) {
          this.apartmentOptions=data.data;
          if(data.data.length>0){
            if(this.$route.query.apartmentId!=undefined&&this.$route.query.apartmentId!=""&&this.$route.query.apartmentId!=null){
               this.selectForm.apartmentId=this.$route.query.apartmentId;
            }else{
               this.selectForm.apartmentId=data.data[0].apartmentId;
            }
            this.getBuildingList();
            this.roomPower();
          }
               
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },

    //获取折线图数据并显示折线图
    getUnlockStatistics(){
         var formData = new FormData();
          formData.append("roomId",this.selectForm.roomId);
          formData.append("beginTime",this.selectForm.yearMonth);
          this.$server
          .exam("/customer/dashboard/getUnlockStatistics", formData)
          .then(data => {
            if (data.code == 200) {
               var staData=data.data;
               console.log(JSON.stringify(data.data));
               var series=[];
               var days=[];
               var staffs=[];
               for(var str in staData){
                   var staffName=staData[str].name
                   staffs.push(staffName);
                   var seriesObj={
                     name: staffName,
                     type: 'line',
                     stack: 'Total',
                     data:[]
                   };
                   var dayCountItems=staData[str].dayCountItems;
                   for(var i in dayCountItems){
                     if(str==0){
                         days.push(dayCountItems[i].day);//天数
                     }
                     seriesObj.data.push(dayCountItems[i].count);//统计数列表
                   }
                   series.push(seriesObj);
               }
               this.echartsInit(staffs,days,series);//加载图
            } else {
               this.$message({
                message: data.message,
                type: "warning"
              });
            }
        });
    },

    //初始化echarts
    echartsInit(staffs,days,series) {
            //柱形图
            //因为初始化echarts 的时候，需要指定的容器 id='main'
            this.$echarts.init(document.getElementById('main')).setOption({
                title: {
                   text: '',
                   textStyle: {
                     color: '#fff'
                   }
                },
                tooltip: {
                   trigger: 'axis'
                },
                legend: {
                  //  data: ['蓝牙', '卡', '指纹', '密码'],
                   data:['B'],
                   textStyle: {
                     color: '#fff'
                   },
                  formatter: this.$t("tenant.tenant")+' {name}'
                },
                grid: {
                   left: '3%',
                   right: '4%',
                   bottom: '3%',
                   containLabel: true
                },
                toolbox: {
                    feature: {
                       saveAsImage: {}
                    }
                },
                xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  data: days,
                  name:this.$t("commom.days")
                },
                yAxis: {
                  type: 'value',
                  minInterval: 1,
                  name: this.$t("commom.openCount"),
                  axisLine:{show:true}
                },
                series:series
                // series: [
                //  {
                //   name: '蓝牙',
                //   type: 'line',
                //   stack: 'Total',
                //   data: [120, 132, 101, 134,101, 134,133]
                //  },
                //  {
                //   name: '卡',
                //   type: 'line',
                //   stack: 'Total',
                //   data: [220, 182, 191, 234,101, 134,122]
                //   },
                //   {
                //     name: '指纹',
                //     type: 'line',
                //     stack: 'Total',
                //     data: [150, 232, 201, 154,101, 134,111]
                //   },
                //   {
                //     name: '密码',
                //     type: 'line',
                //     stack: 'Total',
                //     data: [320, 332, 301, 334,101, 134,98]
                //   },
                // ]
            })
        },
      
    
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/analysisOpenRecord.vue